module.exports = __webpack_public_path__ + "img/cost.d4277f2.svg";